/* import __COLOCATED_TEMPLATE__ from './share-externally.hbs'; */
/* RESPONSIBLE TEAM: team-reporting */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type Report from 'embercom/models/reporting/custom/report';
import type IntlService from 'ember-intl/services/intl';
import safeWindowOpen from 'embercom/lib/safe-window-open';

interface Args {
  report: Report;
  isOpen: boolean;
  onClose: () => void;
}

interface Signature {
  Element: HTMLDivElement;
  Args: Args;
}

export default class ReportingCustomReportShareExternally extends Component<Signature> {
  @service declare intl: IntlService;
  @service analytics: $TSFixMe;

  @tracked recipientEmails: string[] = [];
  @tracked emailSubject = '';
  @tracked personalMessage = '';

  get report(): Report {
    return this.args.report;
  }

  get isGenerateButtonDisabled(): boolean {
    return this.recipientEmails.length === 0;
  }

  @action
  updateRecipients(emails: string[]): void {
    this.recipientEmails = emails;
  }

  @action
  updateSubject(event: Event): void {
    let target = event.target as HTMLInputElement;
    this.emailSubject = target.value;
  }

  @action
  updateMessage(event: Event): void {
    let target = event.target as HTMLTextAreaElement;
    this.personalMessage = target.value;
  }

  @action
  generateAndShareLink(): void {
    // Placeholder logic for link generation and email sharing
    let shareData = {
      reportId: this.report.id,
      reportTitle: this.report.titleForDisplay,
      recipients: this.recipientEmails,
      subject: this.emailSubject,
      message: this.personalMessage,
      timestamp: new Date().toISOString(),
    };

    this.analytics.track('external_sharing_link_generated', {
      report_id: shareData.reportId,
      recipient_count: shareData.recipients.length,
      has_subject: shareData.subject.length > 0,
      has_personal_message: shareData.message.length > 0,
    });

    // TODO: Implement actual API call to generate link and send emails
    // Example: yield this.externalSharingService.generateAndShare(shareData);
  }

  @action
  openHelpArticle(): void {
    // Open help article for external sharing
    safeWindowOpen('https://www.intercom.com/help/en/articles/sharing-reports-externally');

    this.analytics.track('external_sharing_help_opened', {
      report_id: this.report.id,
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Custom::Report::ShareExternally': typeof ReportingCustomReportShareExternally;
    'reporting/custom/report/share-externally': typeof ReportingCustomReportShareExternally;
  }
}
